import $ from '@modules/jquery-import';

$.fn.toggleRadioSelect = function () {

    var $this = this;

    return this.each( function () {
        var radios = $( this ).find( 'input[type="radio"]' );

        return {
            initialize: function () {
                var self = this;
                radios.bind( 'change', function () {
                    self.toggleRadioSelect();
                } );
                this.toggleRadioSelect();
            },
            toggleRadioSelect: function () {
                var self = this;
                radios.each( function () {
                    // forEach radio find assoc labels parent wrapper and remove "selected" className
                    var parent = $( 'label[for="' + this.id + '"]' ).parent();
                    self.disable( parent );

                    // if this item checked add highlight class to wrapper
                    if ( this.checked ) {
                        self.enable( parent );
                        $this.trigger( 'radio:select', parent );
                    }
                } );
            },
            disable: function ( parent ) {
                parent.removeClass( 'selected' )
                    .find( 'input:not([name="' + radios[0].name + '"]), select' )
                    .attr( 'disabled', 'disabled' );
            },
            enable: function ( parent ) {
                parent.addClass( 'selected' ).find( 'input, select' ).removeAttr( 'disabled' );
            }
        }.initialize();

    } );
};
